import React from "react";
import clsx from "clsx";
import { Button } from "@components/ui/button";
import useNavigationStore from "@/lib/stores/useNavigationStore";

function MenuButton() {
  const { isMenuOpen, setIsMenuOpen } = useNavigationStore();

  return (
    <div className="z-30 flex lg:hidden">
      <Button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        variant="ghost"
        className={clsx(
          isMenuOpen ? "opened" : "closed",
          "menu-button flex w-hamburger flex-col justify-center gap-hamburger p-2 align-middle hover:bg-transparent",
        )}
      >
        <span className="line --first"></span>
        <span className="line --second"></span>
        <span className="line --third"></span>
      </Button>
    </div>
  );
}

export default MenuButton;
